export const isImage = (mimetype: string) => /^image/.test(mimetype);
export const isVideo = (mimetype: string) => /^video/.test(mimetype);
export const isAudio = (mimetype: string) => /^audio/.test(mimetype);
export const isPdf = (mimetype: string) => /^application\/pdf/.test(mimetype);
